import { render } from "./GradingPolicyManagement.vue?vue&type=template&id=091b5d9b&scoped=true"
import script from "./GradingPolicyManagement.vue?vue&type=script&lang=js"
export * from "./GradingPolicyManagement.vue?vue&type=script&lang=js"

import "./GradingPolicyManagement.vue?vue&type=style&index=0&id=091b5d9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091b5d9b"]])

export default __exports__